import React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import QandABox from "./QandA";

const generalQuestions = [
  {
    q: "What is manga?",
    a: "TLDR: Manga are Japanese comics, but you probably know that if you're here. But maybe not.",
  },
  {
    q: "How do I download releases?",
    a: `
      Under each release post, there are links. The top row of links are peer-to-peer (P2P) links that require a torrent client. The second row is direct downloads, 
      usually from 3rd-party file sharing sites In the future, we want to include these links under a project page as well, but that will take some time to roll out
      since Silver-Torus was have to figure out database engineering logistics.
    `
  },
  {
    q: "Should I use direct download or peer-to-peer (P2P) to download releases?",
    a: `That is ultimately up to you and how comfortable you are with using peer-to-peer. We do recommend peer-to-peer since download speeds tend to be faster 
       (after the initial few minutes after uploading) and you are helping us and others acquire the file as well. The more people who download via P2P, the more
       likely the file will be around later. This means that if, in the future, your computer drive fails or you brick your phone where you downloaded your releases, you'll be more likely
       to download it again in the future.
    `
  },
  {
    q: "I don't know or don't want to use a torrent client. What if I want to do direct download?",
    a: `You can always use the direct download, but there are some downsides to direct downloads. First, most 3rd-party filesharing sites throttle your download speed, so 
        large release might take a while to acquire. Second, most 3rd-party sites also limit you to a certain number of downloads or megabytes per time period. This might mean
        that if you want to download two files, it would take a lot longer than just using a P2P.` 
  },
  {
    q: `Which P2P program should I use? Any recommendations?`,
    a: `
        qBittorrent is an excellent client that is kept up to date and has more features that probably most need. It also handles large numbers of files (1000+) extraordinarily 
        well without lag or slowdown in the UI. Deluge and Vuze are both good and generally have decent features, but tend to slow down with hundreds of downloads/seeds. 
        Transmission and picoTorrent are good for downloading and seeding, but have few extra features.
      `
  },
  {
    q: `I use a different torrent client than you. Why didn't you list mine?`,
    a: `There is likely nothing wrong with your torrent client, but we have either have not used it before, or it does not have the features we require. Also, we prefer free 
        open source clients whenever possible since their code is easier to inspect and they typically do not have advertisments in them (like the original bittorrent client)
    `
  },
  {
    q: "Is it true that P2P downloading is dangerous and that people can see what you're downloading?",
    a: `Dangerous is a loaded word. Most people don't actually care about what you download, but if you want to protect yourself from the inquisitve eye who might, we recommned
        using a trusted VPN serice. Most of these cost less than 10 USD a month and work on multiple computers. Some services can be configured to run all the time or thorugh a
        router for extra protection.
    `
  },
  {
    q: "A direct download link that was posted is no longer available. Would you please restore it?",
    a: `We will do our best to restore dead links, but we need to be informed that they are missing. If you seeing a missing direct donwload link, please tell us. Be aware
        that if we run out of space on Mega.io or mediafire.com we will have to remove files to make room for new translations. Silver-Torus says
        that he will try to make sure that everything is properly update based on popularity on P2P vs DDL, but there are times that this might not be able to be kept up 
        to date.
    `
  },
   {
    q: "What's with the website? It seems like it's incomplete.",
    a: `
      The website is in it's alpha/beta stage according to Silver Torus, who is the developer. He's doing this completely for free, so he can really only work
      on it when he has time. Silver Torus is trying to add new and useful features within the scope of development, but acknoledges that there are limitations
      with our current hosting plan.
      `
   },
];

const miscellaneousQuestions = [
  {
    q: "What's the long version of 'What is manga?'",
    a: `
    Realistically this is too long and needs to move to its own section, but we'll leave it here for now. Manga is a style of storytelling that utilizes both illustrations and written language to 
    communicate to its reader. The styles of mangaka (manga writers and illustrators) vary greatly between character 
    and background design with some characters and backgrounds being quite simple while others look impressively realistic. The thread that connects all manga, regardless of illustrations and author, 
    is their stylization. Despite there being Chinese and Korean counterparts to manga, called 'manhua' and 'manwha' respectively, manga styles are unique and discernible in most cases due to the 
    stylization. It is this stylization that separates manga from their westerin counterparts known as comics, especially the ever-popular American Comicbook. While we are not comic historians here 
    at Tenkizora, it is generally accepted that American comicbooks originted around 1933 and gained popularity in post World War II. By comparison, Japanese manga are believed to have orginated in
    the Nara period (710-794) by the Japanese copying the style of Chinese handscroll paintings. By the start of the Heian period (794), the Japanese had transformed handscroll painting to an entirely
    new form of art that was distinct from its roots. This was known as "Emakimono" (絵巻物 [えまきもの]) and manga traces its roots to this art style in which stories were illustrated on paper scrolls.
    Perhaps the first story ever illustrated was during the 12th and 13th century called Chōjū-jinbutsu-giga (鳥獣人物戯画 [ちょうじゅうじんぶつぎが]) meaning 'Animal Carictures.' These are credited with being
    the very first manga despite their simplicity. it wouldn't be until Hokusai drew his sketches in 1814-1834 that the word manga would enter common parlance. At this time, Hokusai's Manga, as his collection was 
    called, referred not to the cotemporary story-telling that is known today, but to the varied illustrations he sketched of nature and the supernatural. Regardless, the name caught-on, but its final
    form, as it is known today, would not solidify until post-World War II. During this time, their were a variety internal and external cultural factors that contributed to the development of modern 
    manga. Some of these, including television; film; cartoons; and Disney especially, are believed to have come directly from the United States and impacted the solidification of manga as a medium. Additionally, 
    comics that were popular among US soldiers stationed in Japan are thought to have inlfuenced the modern media to an extent. Whether these extenal influences played a major role or not, is up to interpretation and for historians to determine,
    but what is well understood is that that first modern manga, as we know them, were being written by Osamu Tezuka (Astroboy) and Michiko Hasegawa (Sezae-san) at this time. Osamu Tezuka contributed stylized 
    closeups of charcaters and slow motion shots that are still used today and Michiko Hasegawa's focus on daily life, especially of women, would become the foundation for modern day Shojo. 
    Interestingly, the word manga, which had been retained from Hokusai's works comprise the Japanese kanji "man" (漫 [まん]) meaning whimsical or unrestrained and "ga" (画 [が])' meaning picture. These 
    two words define manga perfectly as manga authors define reality in their stories in a way that does not always mesh with the reality we as humans know or understand. The ability to explore that
    which is not possible, or is at least believed to be impossible, has been a defining feature of humankind for hundreds of years in science, philosophy, and literature. Manga therefore is simply
    another medium through which exploration can occur for both the mangaka (author) and their reader and we hope that you enjoy medium whether it is whimsical, unrestrained, or contemplative since its
    a way of ficticiously exploring unreality (that which is not real, but can be imagined) as Silver-Torus calls it.
    `,
  },
  {
    q: "What is this 'Unreality' that you mention from time-to-time?",
    a: "It is that which is not real or is fictional (ficticious), but can be imagined. It includes anything that and everything that the mind can conceive no matter how realistic or unrealistic, legal or otherwise.",
  },
  // {
  //   q: `I still don't understand "Unreality". How about an anology?`,
  //   a: `Certainly! Playing a video game like Star Wars: Knights of the Old Republic where your character can perform objectively evil actions (as measured by the game) or Skyrim where you can perform
  //   subjectively evil actions (as determined by your own morality or whether you are caught by guards in game) does not make the player evil or even a criminal even if his charcter could be deemed so. This is
  //   unreality. You can explore what it is to be evil without actually bringing those values into and applying them to your actual real life. Unreality is where you can roleplay a character or read
  //   about a character, but be divorced from their actions and mentality, which allows us to explore without actually harming others. It is what allows us to think about doing something outrageous,
  //   horrible, or unbelievable; but not actually be that. Just because I think about flying does not mean that I can fly. Just because I think about punching someone who irritates me does not make
  //   me an assailant. Just because I imagine a spaceship that can travel faster than the speed of light does not mean that I have violated any laws of physics or that I could even build such a ship
  //   or attempt to do so. Everyone has times in their life where the ask the question "what if I did x?" Thinking about doing something is far removed from actually doing it. In law, premediated actions
  //  that are perpetrated are
  //   `
  // },
  // {
  //   q: `Why does this "Unreality" you mention matter?`,
  //   a: `It matters a lot because there are people people who can't divorce the material one consumes from the type of person you actually are. They think that because you play violent viode games or
  //   read sexual material that you must be some kind of criminal or deviant or that you are more prone to acting on urges that you explore in literature, games, manga, whatever. This is simply
  //   not true and has been generally disproven. Certainly there are some people who seek out material that aligns with their real world interests, but not everyone will do so. This is akin to the Raven
  //   Paradox: All Raven's are black does not imply that all non black birds are not ravens. We live in a time where humankind is highly polarized. People deal in absolutes: East vs West,
  //   `
  // }
];

const translationQuestions = [
  {
    q: "What will you translate?",
    a: "Whatever we feel like, but our focus is on Japanese media (and especially manga) that are unlikely to receive a formal translation",
  },
  {
    q: "So what specifically will you translate?",
    a: `Anything we want, but there are three major categories: 1)  material that is unlikely to receive a formal translation 2) anything that has not frequently been considered a (monetarily) successful genre, topic, or media targeting a specifc demographic, 3) Material that is canceled or was "axed"`,
  },
  {
    q: `Will you translate "anything"?`,
    a: "Anything that our translator (Impe7us) and redrawer (Silica) will enjoy/stomach.",
  },
  // {
  //   q: "Will you translate ecchi/smut/hentai/ero or similar genres?",
  //   a: "If that's what you are here for, you're in luck because that's what Silica is here to redraw. Head over to our subdomain sukebei(at)tenkizora(dot)com and see what is offered. Also, note that Tenkizora does cover smut and ecchi, but our subodmain handles anything explicit. There will also be a specific FAQ to handle explict questions about these topics as well.",
  // },
  {
    q: "Are your translations accurate and precise?",
    a: "We aim for accuracy over precision because the momement you try to translate things precisely you end up with a transliteration where you translate single words and string them together. Instead, we try to convey the author's intended meaning to the best or our ability. This should give our readers a better experience. Will write translations notes when necessary.",
  },
  {
    q: `You say you do translation notes. Are they necessary? When do you use them? Where are they?`,
    a: `Translations notes are not always necessary. Whether we feel like we need to include them is based on whether or not we believe a first time manga reader would need them. We treat each project as if its the first time
    that anyone is reading manga and our content. This means that if we do translation notes about something common in Project X Vol 1 Chapter 1, we will not note this again in Chapter 2 unless there is good reason. However if in
    Project Y Vol 1 Chapter 3, the same common thing worth noting occurs, we will address it there since there is not gurantees that readers of Project Y will have read all of Project X. Idioms will always
    recive a translation note since they often require explanation. As for where we write our translation notes, we include them at the end of the translated material because some people hate the distraction of reading them
    alongside their story. We three all have our own opinions of where to place them, so this is a bit of a compromise. We might eventually add the most common translation notes to the website so that those who want more information
    can seek it out if desired. For downloads, translation notes will be placed in their own folder.`,
  },
  {
    q: `How do you plan to handle sound effect (SFX) translation?`,
    a: `Right now we intend to redraw each sound effect as romaji. Japanese have far more ideophones that the english language and while we could translate an onomatopoeia lie "Guuu" to "Growl" there are many different ways 
    other words for "growl" in Japanese, so we would be forced to either find a new word for each ideophone that effectively means the same thing but as just a different intonation or slight sound change or everything would
    be simplified to "growl". For example, "Guuu" becomes "growl", "Uuu" becomes "growl", "Garuru" becomes "growl", "Gao" becomes "growl", "Kyururu" becomes "growl", "Gyuu" comes "growl", "ku" becomes "growl". As you might
    see, this become problematic because this loses some of the effect. So we intened to convert the SFX to romaji and provide a SFX translation in the margin.`,
  },
  {
    q: `Can you draw the sound effects (SFX) another way?`,
    a: `We know that some people are picky and don't like it when SFX are changed. We also know that some people prefer english only sound effects. For logistics and storage reasons,
    we cannot accomodate all styles. Image files with layers take a lot of space when they are uncompressed. If you would like to buy or contribute money for local storage space, let us know and we'll consider doing
    the other styles. For now, we stand by our method of sfx to romaji with a translation in the margin, but if in the future, there is demand for another SFX translation style, we might be persuaded to add it. However,
    there cannot only be 3 people downloading them. That would certainly not be worth it. Additionally, we have future plans for handling this digitally, but we'll cross that road after we get everything up and running 
    first.`,
  },
  {
    q: `Why do you leave Onii-san and Onee-san untranslated instead of translating it to Brother and Sister, respectively. What about sensei? What about in about [insert japanese word X]?`,
    a: `
      The short answer is that localization of translations can ruin nuances of relations between characters, especially since their is no intonation in manga. If you're interested in why, read the long answer below.
    `
  },
  {
    q: `What is the long answer for you leave Onii-san and Onee-san untranslated instead of translating it?`,
    a: `
      The first part of the long answer is that in English rarely anyone refers to their brother or sister as "brother" or "sister" directly. It sounds odd and might come off as cold or even a little creepy.
      For example, "Hello brother. How are you this morning." When we translate, we take into consideration the manga's setting. If the setting takes place in English Victorian Era such as the manga "Moriarty
      the Patriot", we might actually translate it this way since people are often portrayed as speaking that way in that setting. However, if the characters are in Japan or the characters are clearly Japanese,
      we prefer to use the actual words Onii-san and Onee-san. For those, that might ask us to use the character's name instead of "Brother" or "Sister" because that's how people who speaking English do it,
      we will not. Our reasoning is two-fold. First, it completely removes the nuance of these words. Onii-sama is not the same as Onii-san is not same as Onii-chan is not the same as Onii is not the same as using that person's
      name directly. A sibling who refers to their older brother as Onii-sama demonstrates great reverence and respect for their brother (typically as a person). Onii-san demonstrates respect toward the age gap between the older brother and them self, but
      does not necessarily translate into respect for the person. Basically it's a neutral word. Onii and Onii-chan typically demonstrate a close relationship between the speaker and their older brother. Onii could be 
      disrepectful or considered bratty if they are not in fact close while Onii-chan is cute and playful and might be used casually to demonstrate a close relationship or be used when a character is sucking up
      to their brother. Using the person's name directly can be neutral where one's relationship with their brother was not established earlier in life such as when two characters are step-siblings or one is adopted. Or
      it can be disrespectful. However, an older sibling will most always refer to their younger siblings by name unless they are being condescending. The second reason we don't translate it, which is related to the 
      first reaosn is because it erases a cultural nuance and dilutes the media in pursuit of making it more palatable for those who don't want to take a small amount of time to understand the culture and a small
      part of the language. At best this is done by companies and translators to increase readership in hopes of turning a greater profit. At worst, it can be viewed a form of cultural censorship that 
      diverts readers from becoming more knowlegeable and understanding of the culture.
    `
  },
  {
    q: "Are you translations any good?",
    a: "That is really up to the reader to decide. Impe7us tries his best, but he is not a native speaker of Japanese and has been doing this as a learning excercise more than anything. He believes that there will certainly be mistakes and misinterpretations, but that you understand. By contrast, if you are a native speaker of Japanese, feel free to let us know if there is a severe mistake or hidden meaning that was missed. Impe7us is always happy to receive constructive criticism.",
  },
  {
    q: "You suck (or your translations suck)",
    a: "We're sorry you feel that way. If you have legitimate criticisms and are willing to open yourself up to the same criticisms, you can let us know if there is an error; otherwise, we actually aren't too sad you don't like our translation. You can choose not to read it and we stand by that. You're always free to translate manga on your own or collaborate :D",
  },
  {
    q: "Do you take media translation suggestions?",
    a: "Not right now because we have plenty of things that we are intereted in releasing, but maybe later! If there is something you are interested in having translated that is not being translated by another group or compnay, let us know and we will take a look at it. Of course, Impe7us and Silica will have agree to the suggestion, but they are pretty open to suggestions if there isn't anythng already planned",
  },
  {
    q: "Will you accept commisioned work?",
    a: "Possibly in the future. We need to get our bearings first, so not right now. Additionally, the translating and redrawing parties would have to sign off on it, but it's always possible. Nobody wants to translate or redraw something that they don't like or is bothersome.",
  },
];

const dmcaRequests = [
  {
    q: "Do you compensate the mangaka for there efforts?",
    a: "We really want to! If we receive monetary contributions, we would like to work toward a structure where the author receives most of the donations while we receive a translation commission. Whether this will work or not depends on you and the mangaka."
  },
  {
    // q: "In fact, we try to make sure that all authors and companies responsbile for the content are credited, but we sometimes we are not as thorough as we would like. If this is the case, please inform us. As "
  },
  {
    q: "I believe that you are using my material.",
    a: "If you would like us to take down certain material because you are the owner or in possession of the copyright, please let us know. We will happily comply with proper requests."
  },
  {
    q: "I'd like to request a DMCA takedown for a specific reason.",
    a: "We understand that not every mangaka, artist, or company will be happy with what we are doing for various reasons. We promise to have an email that you can contact up at some point soon so that you can contact us. Give us some time to set this up."
  },
  {
    q: "That's my material, but I would like to work with you.",
    a: "That is awesome. And we would like to work with you too! If we could possibly work out some kind of deal and distribution mechanism, we would love to work with you."
  }
];

const personalQuestions = [
  {
    q: "What are some of your favorite manga?",
    impetus:
      `"Darwin's Game", "xxxHolic", "Ori no Eden", "Hinamatsuri", and "Kaguya-sama wa Kokurasetai". It's hard to choose. I like "Darwin's Game" since its a good survival manga; especially since the main character isn't afraid to take charge. "Ori no Eden" enjoyable for the similar reason that its survival but has a novel setting. And I like "xxxHolic" for its beautifully sosphisticated artstyle by Clamp. "Hinmatsuri" is hilarious, but requires a bit of understanding of Japanese humor and "Kaguya-sama: Love is War" is also funny with great charcters that develop over time. I could go write an entire blog on this and maybe will at some point.`,
    silica:
      `For general manga, I'm going with "Infected", "To Love Ru Darkness", and "Chobbits". "Infected" because I like the zombie aspect and the characters grow on you with time. It's not too deep so it's easy to consume and enjoy. "Chobbits" because it's one of the first Manga I picked up to read at the library, so there's some nostalgia there for me. "To Love Ru" has awesome ecchi and I like some good ecchi in my general manga (heehee)`,
    silverTorus:
      `Not my top three rated, but my favorite manga are "Ajin", "Knights of Sidonia", and "Mx0" and it was cancelled, which might be some of the reason why I am participating in Tenkizora. As for some others, I liked "Knights of Sidonia" for its sparse and complex artstyle. I really enjoyed the aesthetic`,
  },
  {
    q: "What's your favorite anime?",
    impetus:
      `There's too many good ones to list, but if we're talking films... anything done by Makoto Shinkai is beautiful and I also like Miyazaki's works. Otherwise, "Shinsekai Yori", "Psycho-Pass", "Toradora" are all great. And "Shakugan no Shana" is fun too and one of the first 10 anime I probably ever watched.`,
    silverTorus:
      `"Pyscho-Pass", "Shinsekai Yori", "Time of Eve" (Eve no Jikan), "Serial Experiments Lain", and "Cowboy Bebop" to name a few.`,
    silica:
      `Not as much experience as either of these two, but "Konosuba" and "Howl's Moving Castle" are great for different reasons.`
  },
  {
    q: "Do you have a favorite genre of anime and/or manga?",
    impetus:
      "Survival manga are pretty obvious from the my selection of manga, but I also love Sci-Fi of any kind. It can be hard or soft, but it needs to have interesting characters or setting.",
    silica:
      "I enjoy ecchi if that's a genre and horror if it's good. It just hit different.",
    silverTorus: "Sci-Fi and Psychological manga and anime are my thing.",
  },
  {
    q: "Of the Big Three? Which is your favorite",
    impetus: "\"Naruto\"",
    silica: "Haven't read them. Might try \"One Piece\". It looks extra.",
    silverTorus:
      "\"Bleach\" until the Hueco Mundo Arc. The story branched too much at that point and I started losing interest, so \"Naruto\".",
  },
  // {
  //   q: "What's your age?",
  //   impetus: "Older than I'd like to admit, but still pretty young.",
  //   silica: "Prefer not to say, but I'm sure you can guess.",
  //   silverTorus:
  //     "Millenial. You can calculate the range or ask chat GPT or something.",
  // },
  {
    q: "Current manga that you are most excited to start reading?",
    impetus: "I want to reread \"Sekai Oni\". I rememeber it being good, but I barely remember it at this point.",
    silica: "Maybe... some of the ones we're plannnig to release. Uhhhm. Also, maybe \"The Promised Neverland\".",
    silverTorus:
      "\"Boku no Hero Academia\". I still haven't read it, but only because I've really want to binge it when it's complete.",
  },
  {
    q: "Current anime that you are most excited to watch?",
    impetus:
      "Too many... Season 3 of '\"Youkouso Jitsuryoko...\", \"Youjo Senki\" Season 2, and \"Oshi no Ko\"",
    silica: "Konsuba Season 3",
    silverTorus: "Miyazki's \"The Boy and the Heron\"",
  },
  // {
  //   q: "What anime could you rewatch over-and-over again?",
  //   impetus: "Makoto Shinkai's Films ",
  //   silica: "",
  //   silverTorus: "",
  // },
  // {
  //   q: "What manga could you reread over-and-over again?",
  //   impetus: "",
  //   silica: "",
  //   silverTorus: "",
  // },
  {
    q: "Current manga that you are most excited translate?",
    impetus:
      "It's a secret, but I'm currently excited to finish \"Tsuioku no Apeiron\".",
    silica:
      "I can't say here because it slaps too hard. Nah. It's just not family friendly on this site. You'l be able to see it when our other subdomain goes live.",
    silverTorus: "I'm not allowed to say until the first volume is released.",
  },
  {
    q: "Do you read light novels? And if so, what are your favorite novels?",
    impetus:
      "Yes, \"86\" is great and \"Mahou Koukou no Rettousei\" is excellent and worth reading far more than watching it as anime. Tatsuya becomes two-dimensional in the anime, but is a far more interesting character in the novels because you see his thought process in action",
    silica: "Not really, maybe some day.",
    silverTorus: "Only a few and its more likely if its a standalone",
  },
];

const supportQuestions = [
  {
    q: `Can I help you translate? Typeset? Edit? Quality Check?`,
    a: `It's nice of you to offer, but right now we're just trying to get up and running. Perhaps in the future if we decide we need help or want to expand?`,
  },
  {
    q: `Is there anything I can do to help if I can't directly participate in the translation process?`,
    a: `You can donate a small sum of money or cryptocurrency through one of our supported platforms. Check out to support page for details. `,
  },
  // {
  //   q: `You're asking for 3-5 USD, does it actually help?`,
  //   a: `We actually don't want to beg or pander for large sums and micropayments are often more affordable for users, so we don't ask for much. Even $1 is helpful and moves us
  //   closer to independence.  If everyone paid $1 for each release, we could probably do this full-time. We know this isn't likely to happen, but if you have ever enjoy one of our releases
  //   consider a one time donation or contributing via Patreon of Ko-fi with a subscription.
  //   `,
  // },
  {
    q: `Do I get anything for donating?`,
    a: `Not right now, but we hope to provide everyone who does contribute with some something in the future. We can't promise anything at this time because the website and its features 
    are not fully online at this moment, and if we are able to provide something, we can only provide this to those who do not support us anonymously.
    If you wish to be considered for potential future rewards, email us at contact(at)tenkizora(dot)com and let us know you're transaction number, along
    with your email address (for Venmo, Patreon, Ko-Fi, etc. if its different from the one) you're using to email us.
    `
  },

  // {
  //   q: `I supported you through Venmo or Crypto. Will I still recieve compensation if it becomes available?`,
  //   a: `Yes. Ideally we would like to automate the process in the future, but for now you will have to email us at contact(at)tenkizora(dot)com and let us know you're transaction number, along
  //   with your email address (for Venmo, Patreon, Ko-Fi, etc. if its different from the one) you're using to email us`,
  // },

  // {
  //   q: `What would I receive if I donate?`,
  //   a: `
  //     We really can't say right now since we don't want to promise anything... sorry. But for now, you would be help ing 
  //   `
  // }
  // {
  //   q: `I don't have funds to donate. Is there anything else I can do?`,
  //   a: `If you have old highspeed storage devices like NVME, SSDs or HDDs with 4TB of storage or greater, we would gladly accept them for media storage purposes. Image editing requires a shockingly large amount of space.
  //   Each project takes approximately 5-10GBs of disk space if we want the ability to maintain quality backups. Any little bit of extra spaces can help. `
  // },
];

const FAQ = () => {
  return (
    <Stack
      minWidth="320px"
      maxWidth="1024px"
      m="0 auto"
      spacing={2}
      paddingTop={2}
    >
      <Stack spacing={2} textAlign="start">
        <Typography variant="h4">General Questions</Typography>
        {generalQuestions.map((faq, index) => (
          <QandABox key={index} values={faq} answerSpacing={30} />
        ))}
      </Stack>

      <Stack spacing={2} textAlign="start" paddingTop={4}>
        <Typography variant="h4">Translation Questions</Typography>
        {translationQuestions.map((faq, index) => (
          <QandABox key={index} values={faq} answerSpacing={30} />
        ))}
      </Stack>

      <Stack spacing={2} textAlign="start">
        <Typography variant="h4">Miscellaneous Questions</Typography>
        {miscellaneousQuestions.map((faq, index) => (
          <QandABox key={index} values={faq} answerSpacing={30} />
        ))}
      </Stack>

      <Stack spacing={2} textAlign="start" paddingTop={4}>
        <Typography variant="h4">Get to know us</Typography>
        {personalQuestions.map((faq, index) => (
          <QandABox
            key={index}
            values={faq}
            answerSpacing={110}
            questionSpacing={110}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default FAQ;
